<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div
    class="mobile-nav-bar d-flex justify-content-between"
    [ngClass]="isCorporate ? 'bg-primary-corporate mobile-navbar-corporate' : 'bg-primary mobile-navbar-default'"
  >
    <a class="nav-item font-weight-bold brand p-0" [routerLink]="['/']" routerLinkActive="router-link-active">
      <ng-container *ngIf="!isCorporate && !isJuniorBluebirds"
        ><img class="home-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false"
      /></ng-container>
      <ng-container *ngIf="isCorporate"
        ><img class="home-logo" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false"
      /></ng-container>
      <ng-container *ngIf="isJuniorBluebirds"
        ><img class="home-logo" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false"
      /></ng-container>
    </a>
    <div class="d-flex align-items-center">
      <a class="nav-item me-3">
        <fgb-notification-button></fgb-notification-button>
      </a>
      <button class="nav-item navbar-toggler m-0 ps-2 pe-0" (click)="isCollapsed = !isCollapsed">
        <span class="icon material-symbols-outlined material-mobile-nav hamburger-icon mb-0 text-white">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-menu-dropdown"
    [ngClass]="{
      'bg-primary-corporate': isCorporate,
      'bg-white': !isCorporate && !isJuniorBluebirds,
      'bg-primary': isJuniorBluebirds,
    }"
  >
    <div class="d-flex flex-column pt-0 mobile-nav-menu-content">
      <!-- Club Logo -->
      <div class="d-flex align-items-center mt-2 justify-content-between mb-6px">
        <ng-container *ngIf="!isCorporate && !isJuniorBluebirds"
          ><img class="brand" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" (click)="navigateToHome()"
        /></ng-container>
        <ng-container *ngIf="isCorporate"
          ><img class="brand" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false" (click)="navigateToHome()"
        /></ng-container>
        <ng-container *ngIf="isJuniorBluebirds"
          ><img class="brand" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false" (click)="navigateToHome()"
        /></ng-container>
        <button
          class="close-button border-0 p-0"
          [ngClass]="isCorporate || isJuniorBluebirds ? 'text-white' : 'text-info'"
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="icon material-symbols-outlined cancel"> close </span>
        </button>
      </div>

      <div class="mobile-nav-button-container mt-3">
        <!-- Nav Buttons -->
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined me-3"> account_circle </span>
          <div class="nav-text">{{ 'navbar.profile' | translate }}</div>
        </a>
        <ng-container *notInPopulation="[populations.Free]">
          <a
            [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
            [routerLink]="['/rewards']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            *notInPopulation="[populations.Free]"
          >
            <span class="material-symbols-outlined me-3"> redeem </span>
            <div class="nav-text">{{ 'navbar.rewards' | translate }}</div>
          </a>
        </ng-container>

        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined me-3"> trophy </span>
          <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
        </a>
        
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          [routerLink]="['/games']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined me-3"> sports_esports </span>
          <div class="nav-text">{{ 'navbar.games' | translate }}</div>
        </a>

        <ng-container *notInPopulation="[populations.Free]">
          <a
            [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            *notInPopulation="[populations.Free]"
          >
            <span class="material-symbols-outlined me-3"> account_balance_wallet </span>
            <div class="nav-text">{{ 'navbar.wallet' | translate }}</div>
          </a>
        </ng-container>
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          [routerLink]="['/earn']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          *notInPopulation="[populations.JuniorBluebirds]"
        >
          <span class="material-symbols-outlined me-3"> loyalty </span>
          <div class="nav-text">{{ 'navbar.earnpoints' | translate }}</div>
        </a>
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.nav.gallery'">
          <a
            [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
            [routerLink]="['/gallery']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            *notInPopulation="[populations.Free]"
          >
            <span class="material-symbols-outlined me-3"> animated_images </span>
            <div class="nav-text">{{ 'navbar.gallery' | translate }}</div>
          </a>
        </ng-container>
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          *inPopulation="[populations.JuniorBluebirds]"
        >
          <span class="material-symbols-outlined me-3"> tactic </span>
          <div class="nav-text">{{ 'navbar.activities' | translate }}</div>
        </a>
        <div class="help-wrapper">
          <div
            class="help-dropdown"
            [ngClass]="{
              'corporate-nav-item': isCorporate || isJuniorBluebirds,
              'nav-item': !isCorporate,
              'mb-3': isHelpMenuOpen,
            }"
            (click)="toggleHelpMenu()"
          >
            <span class="material-symbols-outlined me-3">info</span>

            <span class="nav-text">
              {{ 'nav.help' | translate }}
            </span>

            <span class="material-symbols-outlined arrow" [class.open]="isHelpMenuOpen"> expand_more </span>
          </div>

          <div class="help-submenu mb-3" [class.open]="isHelpMenuOpen">
            <a
              class="help-submenu-item nav-text"
              [ngClass]="{ 'text-white': isCorporate || isJuniorBluebirds }"
              [routerLink]="['/terms']"
              (click)="isHelpMenuOpen = false"
            >
              {{ 'nav.terms' | translate }}
            </a>

            <a
              class="help-submenu-item nav-text"
              [ngClass]="{ 'text-white': isCorporate || isJuniorBluebirds }"
              [routerLink]="['/faq']"
              (click)="isHelpMenuOpen = false"
            >
              {{ 'nav.faq' | translate }}
            </a>

            <a
              class="help-submenu-item nav-text"
              [ngClass]="{ 'text-white': isCorporate || isJuniorBluebirds }"
              [routerLink]="['/contact']"
              (click)="isHelpMenuOpen = false"
            >
              {{ 'nav.contact.us' | translate }}
            </a>
          </div>
        </div>
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          href="{{ 'nav.cardiff.official.url' | translate }}"
          target="_blank"
        >
          <span class="material-symbols-outlined me-3"> captive_portal </span>
          <div class="nav-text">{{ 'navbar.cardiff.website' | translate }}</div>
        </a>
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          href="{{ 'nav.cardiff.superstore.url' | translate }}"
          target="_blank"
        >
          <span class="material-symbols-outlined me-3"> storefront </span>
          <div class="nav-text">{{ 'navbar.cardiff.store' | translate }}</div>
        </a>
        <a
          [ngClass]="isCorporate || isJuniorBluebirds ? 'corporate-nav-item' : 'nav-item'"
          href="{{ 'nav.cardiff.city.tv.url' | translate }}"
          target="_blank"
          *notInPopulation="[populations.Free]"
        >
          <span class="material-symbols-outlined me-3"> live_tv </span>
          <div class="nav-text">{{ 'navbar.cardiff.tv' | translate }}</div>
        </a>

        <!-- Logout Button -->
        <a
          class="log-out py-1 w-100 mb-5"
          data-bs-dismiss="offcanvas"
          [ngClass]="{ 'corporate-logout-item': isCorporate || isJuniorBluebirds }"
          (click)="logout()"
        >
          <i class="material-symbols-outlined">logout</i>
          <div class="nav-text text-capitalize font-size-14">{{ 'navbar.logout' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
